module.exports = __webpack_public_path__ + "static/img/background.51d4a2b7.svg";